import urlLib from 'x-url';

const SLICE_COUNT = 1;
const MIN_LANG_LENGTH = 2;

// required change DEFAULT_LANGUAGE
export const DEFAULT_LANGUAGE = window.default_language;
export const LANGUAGES = window.languages

export function clean(url: string): string {
  return url.replace(/\/+/gim, '/');
}

export function getRelative(url = ''): string {
  if (!url.startsWith('http')) {
    return url;
  }

  const object = urlLib.parse(url);

  return object.path;
}

export function getPrefixed(url: string, prefix: string | null = null): string {
  if (!prefix) {
    return url;
  }

  return clean(prefix + getRelative(url));
}

export function getLanguageCode(url = ''): string {
  const [lang] = getRelative(url)
    //eslint-disable-next-line
    .replace(/^[\/]+|[\/]+$/g, '')
    .split('/', SLICE_COUNT);

  if (!lang || lang.length > MIN_LANG_LENGTH) {
    return DEFAULT_LANGUAGE;
  }

  return lang;
}

export const CURRENT_LANGUAGE = (window && window.location && getLanguageCode(window.location.href)) || DEFAULT_LANGUAGE;

export function removeLanguage(path = ''): string {
  const currentLanguageCode = getLanguageCode(path);

  if (currentLanguageCode === DEFAULT_LANGUAGE) {
    return path;
  }

  return path.slice(currentLanguageCode.length + SLICE_COUNT);
}

export function prefixLanguage(url = '', { language = CURRENT_LANGUAGE } = {}): string {
  const path = removeLanguage(getRelative(url));

  if (!language || language === DEFAULT_LANGUAGE) {
    return path;
  }

  return getPrefixed(path, `/${language}/`);
}
